<template>
  <div>
    <div class="image-preview" v-if="imageData.length > 0">
      <img class="preview" :src="imageData">
    </div>
    <div class="image-preview" v-if="imageData.length == 0">
      <img class="preview" :src="imageRoot + preview">
    </div>
    <div class="file-upload-form">
      <input @change="selectedFile" type="file" :accept="accept">
      {{accept.replace(/image\//g, '')}}のみアップロード可能<br>
      サイズは 幅{{width}}px * 高さ{{height}}px
      <br>
      <br>
      <button @click="upload">アップロード</button>
    </div>
    <div v-if="imageMessage">
      {{imageMessage}}
    </div>
  </div>
</template>
<script>
  import Api from '@/service/Api.vue'

  export default {
    props: ['foldername', 'filename', 'preview', 'accept', 'width', 'height'],
    data () {
      return {
        imageRoot: process.env.IMAGE_ROOT,
        imageData: '',
        uploadFile: null,
        imageMessage: '※ファイル選択後、アップロードしてください'
      }
    },
    methods: {
      selectedFile: function (e) {
        var me = this
        e.preventDefault()
        let files = e.target.files

        me.uploadFile = files[0]

        // 拡張子チェック
        var fileType = me.uploadFile.name.split('.')
        var acceptTypes = this.accept.replace(/image\//g, '').replace(/ /g, '').split(',')
        var isAccept = false

        acceptTypes.forEach(function (acceptType) {
          if (fileType[fileType.length - 1].toLowerCase() === acceptType) {
            isAccept = true
          }
        })

        if (!isAccept) {
          return alert('拡張子が異なります')
        }

        // 画像サイズチェック
        var img = new Image()
        img.onload = function () {
          var width = me.width || false
          var height = me.height || false
          if (width && height && (this.width !== Number(me.width) || this.height !== Number(me.height))) {
            return alert('幅と高さが異なります。幅：' + img.width + 'px, 高さ：' + img.height + 'px')
          } else {
            var input = e.target
            if (input.files && input.files[0]) {
              var reader = new FileReader()
              reader.onload = (e) => {
                me.imageData = e.target.result
              }
              // Start the reader job - read file as a data url (base64 format)
              reader.readAsDataURL(input.files[0])
            }

            me.imageMessage = '※画像を確認し、アップロードをしてください'
          }
        }
        img.src = (window.URL || window.webkitURL).createObjectURL(me.uploadFile)
      },
      upload: function () {
        // FormData を利用して File を POST する
        let formData = new FormData()
        formData.append('image', this.uploadFile)
        if (!this.uploadFile) {
          this.imageMessage = 'ファイルを選択してください。'
          return
        }
        let config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
        Api.image.upload(this.foldername, this.filename, formData, config)
          .then(this.successResponse)
          .catch(this.catchResponse)
      },
      successResponse: function (response) {
        this.imageMessage = 'アップロードしました'
        var file = response.data.file || ''
        this.$emit('input', file)
      },
      catchResponse: function (response) {
        this.imageMessage = 'アップロードに失敗しました'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ImagePreview.vue?fe14bf5c